import type { IconProps } from '../types/IconProps.ts';
export const Zap: IconProps = {
    name: 'Zap',
    children: [
        `<path d="M14.09 1.99a.5.5 0 0 1 .86.36l-.2 6.2a.5.5 0 0 0 .5.52h4.66c.43 0 .66.5.38.83L10 21.83a.5.5 0 0 1-.88-.37l.6-6.9a.5.5 0 0 0-.5-.54H4.14a.5.5 0 0 1-.37-.84z" />`,
    ]
};